<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct" id="toc_marker-1">A Few Right Thinking Men</p>
<p class="book-subtitle" xml:lang="en-GB">A Rowland Sinclair Mystery</p>
<p class="book-author" xml:lang="en-GB">Sulari Gentill</p>
<p class="body-center"><a class="calibre1" href="http://www.SulariGentill.com" target="_blank"><span class="hyperlink" xml:lang="en-US">www.SulariGentill.com</span></a></p>
<p class="book-publisher" xml:lang="en-GB"><span class="char-style-override">Poisoned Pen Press</span></p>
<p class="body-center"><span class="calibre1"><img alt="PPPlogo.jpg" class="frame" src="OEBPS/image/PPPlogo_fmt.png"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// A_Few_Right_Thinking_Men.vue?79d470cc